<template>
  <div
    :class="{
      'table-cell__focus': inFocus
    }"
    class="table-cell"
  >
    <slot>
      <label class="content-wrapper">
        <Select
          :value="value"
          :options="options"
          class="select__borderless"
          @focus="inFocus = true"
          @blur="inFocus = false"
          @change="$emit('change', $event)"
        />
      </label>
    </slot>
  </div>
</template>

<script>
import Select from '@/components/_base/elements/Select'

export default {
  name: 'TableSelectCell',
  components: {
    Select
  },
  props: {
    /** Valor do input */
    value: {
      type: Object
    },
    /**
     * Opções do input
     *
     * {
     *  text: String,
     *  value: String, Number
     * }
     */
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      inFocus: false
    }
  }
}
</script>

<style lang="scss" scoped>
.table-cell {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 0 0 transparent inset;
  cursor: pointer;
  transition: box-shadow $anim-fast linear;

  .content-wrapper {
    width: 100%;
  }

  .select {
    &__borderless {
      &,
      ::v-deep .select--button {
        border: none;
        font-size: font-size('size-small');
      }

      ::v-deep .select--button {
        box-sizing: border-box;
        padding: 0 15px;
      }
    }
  }

  &__focus {
    box-shadow: 0 0 1px 2px $blue inset;
  }
}
</style>
